import { Component, OnInit } from '@angular/core';
import { NavigationService, SettingNavigationItem } from 'src/app/core/navigation.service';

@Component({
  selector: 'app-settings-data',
  templateUrl: './settings-data.component.html',
  styleUrls: ['./settings-data.component.scss'],
})
export class SettingsDataComponent implements OnInit {
  settings: SettingNavigationItem[] = [];

  constructor(private navigation_service: NavigationService) {}

  ngOnInit(): void {
    this.settings = [...this.navigation_service.navigation_set.settings_items.values()];
  }
}
